

































import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

import InformationRow from '@/components/display/information-row.vue';
import Toast from '@/components/display/toast.vue';
import AdrLookup from '@/components/adr-lookup.vue';
import { AddressExtended, OrgExtended } from '@/models/extensions';
import { AddressService } from '@/services/address-service';

@Component({
	components: {
		InformationRow,
		AdrLookup,
	},
})
export default class OrgAddressSearch extends Vue {
	@Prop({ required: true, type: Object })
	public org!: OrgExtended;

	private addressService: AddressService = new AddressService();

	public editing: boolean = false;
	public newAddress: AddressExtended = {};
	public submitting: boolean = false;

	private toast: Toast = new Toast();

	public created(): void {
		this.setAddress();
	}

	private setAddress() {
		this.newAddress = {
			fullAdr: this.org?.address?.fullAdr ?? undefined,
			rawAddress: this.org?.address?.rawAddress ?? null,
		};
	}

	public toggleEditing(): void {
		this.editing = !this.editing;
		if (!this.editing) this.setAddress();
	}

	public async updateAddress(): Promise<void> {
		if (!this.newAddress?.rawAddress || this.submitting || !this.org?.id) return;

		this.submitting = true;

		let creating = !this.org.address;
		let response;
		if (!this.org.address) {
			this.org.address = {
				ownerType: 'orgs',
				ownerId: this.org.id,
				type: 'street',
				...this.newAddress,
			};
			response = await this.addressService.addAddress(this.org.address);
		} else {
			this.org.address.fullAdr = this.newAddress.fullAdr ?? undefined;
			this.org.address.rawAddress = this.newAddress.rawAddress;
			response = await this.addressService.updateAddress(this.org.address);
		}

		this.editing = false;
		this.submitting = false;

		if (response.errorMessage) {
			this.toast.makeToast(
				response.errorMessage,
				`Error ${creating ? 'Setting' : 'Updating'} Org Address`,
				'danger',
				true,
			);
			return;
		}

		const action = creating ? 'set' : 'changed';
		this.toast.makeToast(
			`Address for org ${this.org.name} ${action} to ${this.newAddress.fullAdr}`,
			`Org Address ${action.substring(0, 1).toUpperCase()}${action.substring(1)}`,
			'success',
		);
	}
}
